import { formatError } from "@/helpers/filters";
import { ignoreRouterRedirectFailure } from "@/helpers/routerNavigation";
import AuthService from "../services/auth-service";


export default {
    name: "user",
  
    data: () => ({
      user: {
        userEmail: null,
        userPassword: null,
      },
      errorMessageLogin: '',
      dialog: false,
      snackbar: false,
      snackbarColor: "info",
      snackbarMessage: "",
      checkbox: false,
      shakeAnimated: false,
      isLoading: false,

      rulesEmail: [
        (value) => !!value || "Campo obrigatório",
        (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Email inválido";
        },
      ],
  
      rulesPassword: [
        (value) => !!value || "Campo obrigatório",
        (value) => (value && value.length >= 8) || "Min 8 caracteres",
      ],

    }),

  methods: {
    showToast(message, color = "info") {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    consumeLoginFeedback() {
      const loginFeedback = window.sessionStorage.getItem("loginFeedback");
      if (!loginFeedback) {
        return;
      }

      this.showToast(loginFeedback, "warning");
      window.sessionStorage.removeItem("loginFeedback");
    },
    redirectToRecoverPassword(email) {
      if (email) {
        this.$store.state.user.email = email;
      }

      this.showToast("Seu acesso precisa passar pela redefinição de senha.", "warning");

      setTimeout(() => {
        this.$router.push({
          path: "/recover-password",
          query: {
            ...(email ? { email } : {}),
            reason: "first-login",
          },
        });
      }, 1000);
    },
    async authenticateUser() {
      if (!this.user.userEmail || !this.user.userPassword) {
        this.showToast("Preencha e-mail e senha para continuar.", "warning");
        this.shakeAnimated = true;
        setTimeout(() => { this.shakeAnimated = false }, 1000);
      } else {
        try {
          localStorage.clear();
          this.$store.state.user.email = this.user.userEmail;
          this.isLoading = true
          const response = await AuthService.login(this.user)
          if (String(response?.code) === '403' && response?.message === 'FIRST_LOGIN_REDIRECT') {
            this.redirectToRecoverPassword(this.user.userEmail)
            return
          }
          this.$router
            .push(this.$route.query.redirect || "/dashboard/campaigns")
            .catch(ignoreRouterRedirectFailure);
        } catch (error) {
          this.errorMessageLogin = formatError(error.message)
          this.dialog = true
          setTimeout(() => { this.dialog = false }, 3000);
        } finally {
          this.isLoading = false
        } 
      }
    }
  },
  watch: {
    "$route.query.feedbackAt"() {
      this.consumeLoginFeedback();
    }
  },
  beforeMount(){
    this.consumeLoginFeedback();

    if (localStorage.sessionId && localStorage.redirect == "null") {
      this.$router.push("/dashboard/campaigns").catch(ignoreRouterRedirectFailure);
    }
    
  }
};
  